// @flow

import { CollectionActionActions } from '../../store/orm/Action';

export const fetchCollectionActions = ({ match }: any) =>
  CollectionActionActions.fetchCollectionActions(match.params.collectionId);
